
const EditIcon = ({ onClick }) => <span className={`
	table-edit-icon
	opacity-0 
	flex items-center justify-center font-MaterialIcons text-grey font-normal text-xl cursor-pointer scale-100 transition-all
	hover:scale-125 hover:text-primary active:scale-95
	group-hover/edit-content:opacity-100
`}
	onClick={onClick}>
	edit
</span>

export default EditIcon

